module.exports = __webpack_public_path__ + "81d38a507ad386e72bd50ae6fef6f5f6.svg";